import React from "react";

function ApDisplayImage(props) {
  return (
    <img
      draggable={false}
      onDragStart={e => e.preventDefault()}
      alt="Media"
      src={props.file}
    />
  );
}

export default ApDisplayImage;



// WEBPACK FOOTER //
// ./src/components/approval/ApDisplayImage.js